var current_fetch_url = $('.load-more-btn').attr('data-page');
$(document).on('click','.load-more-btn', function (e) {
  e.preventDefault();
  if ($('.family-blog').length == 0) {
    $('.product-grid-container').append('<div class="hilx_loading" style="display: block;">Loading…</div>')
    $(`.hilx_loading`).css(`display`, `block`);
  }
  current_fetch_url = $(this).attr('data-page');
  fetch(current_fetch_url)
  .then((response) => {
    return response.text();
  })
  .then((responseText) => {
    if (responseText == null) {
      return;
    }
    handleResponse(responseText);
  })
  .catch((e) => {
    console.error(e);
  })
});

function handleResponse(responseText) {
  const html = new DOMParser().parseFromString(responseText, 'text/html');
  if ($(html).find('.product-grid').length > 0) {
    $('.product-grid').append($(html).find('.product-grid li.grid__item'))
  }
  if ($(html).find('.family-blog').length > 0) {
    $('.family-blog').append($(html).find('.family-blog .family-blog-card'))
  }
  $('.load-more-btn[data-page="' + current_fetch_url + '"]').parent().remove();
  if ($(html).find('.load-more-wrapper').length > 0) {
    $('.product-grid-container .collection').append($(html).find('.load-more-wrapper'));
    $('.family-blog').append($(html).find('.load-more-wrapper'));
  }
  if ($('.family-blog').length == 0) {
    $(`.hilx_loading`).css(`display`, `none`);
  }
}